var exports = {
  "T9": "searchMatchText__mKbuP6",
  "Y2": "truncatedName__rjqBL8",
};

module.exports = exports;
